import {PlayerReduxState} from "../types";

export default function isLastUserInputError(state: PlayerReduxState): boolean {
  return state.currentActionAttempts !== 0;
}